import { APIProvider, Map, AdvancedMarker, InfoWindow, Pin } from "@vis.gl/react-google-maps";
import { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import LeafletMap from "./EventsMap";
import { formatDateRange } from "../lib/constants";

const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export default function GoogleEventsMap({ events, height = "500px" }) {
  const points = useMemo(() => events.filter(e => e.lat && e.lng), [events]);
  const [selected, setSelected] = useState(null);

  // Fallback to Leaflet if no Google Maps API key set
  if (!GOOGLE_KEY) {
    return <LeafletMap events={events} height={height} />;
  }

  const center = points[0] ? { lat: points[0].lat, lng: points[0].lng } : { lat: 48.5, lng: 10 };

  return (
    <div className="border border-border rounded-sm overflow-hidden" style={{ height }}>
      <APIProvider apiKey={GOOGLE_KEY}>
        <Map
          defaultCenter={center}
          defaultZoom={5}
          mapId="wheelsmeet_dark"
          gestureHandling="greedy"
          disableDefaultUI={false}
          colorScheme="DARK"
          data-testid="google-events-map"
        >
          {points.map((e) => (
            <AdvancedMarker key={e.event_id} position={{ lat: e.lat, lng: e.lng }} onClick={() => setSelected(e)}>
              <Pin background={"hsl(3 100% 59%)"} borderColor={"#000"} glyphColor={"#000"} scale={e.is_featured ? 1.3 : 1} />
            </AdvancedMarker>
          ))}
          {selected && (
            <InfoWindow position={{ lat: selected.lat, lng: selected.lng }} onCloseClick={() => setSelected(null)}>
              <div style={{ minWidth: 200, color: "#111" }}>
                <div style={{ fontFamily: "'Unbounded', sans-serif", fontWeight: 800, fontSize: 14, marginBottom: 4, letterSpacing: "-0.02em" }}>{selected.title}</div>
                <div style={{ fontSize: 11, color: "#555", marginBottom: 6 }}>{selected.city}, {selected.country}</div>
                <div style={{ fontSize: 11, color: "hsl(3 90% 45%)", marginBottom: 8, fontWeight: 600 }}>{formatDateRange(selected.date_start, selected.date_end)}</div>
                <Link to={`/events/${selected.event_id}`} data-testid={`gmap-popup-link-${selected.event_id}`} style={{ display: "inline-block", padding: "6px 12px", background: "hsl(3 100% 59%)", color: "white", fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", textDecoration: "none" }}>Dettagli →</Link>
              </div>
            </InfoWindow>
          )}
        </Map>
      </APIProvider>
    </div>
  );
}
